export default __webpack_public_path__ + "static/media/studentRealCase2-en.d1ba4599.png";